export default "__VITE_ASSET__YJZuMIZ9__"